<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text {{ $t('domain_verifications') }}
        v-divider.basic300
        v-card.pa-0(flat)
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          div.pa-4(v-else)
            .s1.basic1000--text {{ $t('facebook_meta_tag') }}
            .c1.basic1000--text {{ $t('facebook_meta_tag_text') }}
            code.c1.basic1000--text {{ metaTagExample }}
            div.mt-4
            .custom-domain(v-for="(domain, index) in domains" :key="domain.id")
              p.mb-1.label.basic600--text {{ domain.name }}
              v-text-field.mt-2(v-model='domains[index].verification.code' placeholder="Example: fapmvcccql4vf7rmkqcrp5euc9pa8fp" background-color="basic200" outlined dense height="40" :maxlength="30")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='info500' dark depressed height=32 @click="clickSave" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'

let asyncForEach = async function (array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export default {
  name: 'DomainVerifications',
  props: ['open', 'settings', 'company'],
  data: () => ({
    isFetching: false,
    metaTagExample: '',
    domains: [],
    isLoading: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    formDomainName () {
      return `${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}`
    },
    storeDomainName () {
      return `${this.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}`
    }
  },
  mounted () {
    this.loadDomain()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    loadDomain () {
      this.isFetching = true
      this.$axios.get(`/domains/?company=${this.company.id}`)
        .then((response) => {
          this.domains = response.data.results
          this.domains.splice(0, 0, { name: this.storeDomainName })
          this.domains.splice(0, 0, { name: this.formDomainName })
          this.loadVerifications()
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.$axios.get(`https://${this.company.slug}.${process.env.VUE_APP_BASE_DOMAIN}/meta-tag/facebook.txt`)
            .then(({ data }) => {
              this.metaTagExample = data.toString()
            })
            .catch(() => {})
        })
    },
    async loadVerifications () {
      let index = 0
      await asyncForEach(this.domains, async (domain) => {
        const resp = await this.axios.get(`/domain_verifications?domain=${domain.name}`)
        if (resp.data.results.length > 0) {
          this.domains[index].verification = resp.data.results[0]
        } else {
          this.domains[index].verification = {
            id: null,
            domain: domain.name,
            code: null
          }
        }
        index++
      })
      this.isFetching = false
    },
    async clickSave() {
      const saveDomains = this.domains.filter(domain => domain.verification.code)
      if (saveDomains.length == 0) {
        return
      }
      let hasError = false
      this.isLoading = true
      await asyncForEach(saveDomains, async (domain) => {
        const data = {
          company: this.company.id,
          platform: 1,
          code: domain.verification.code
        }
        try {
          if (domain.verification.id && domain.verification.code) {
            await this.axios.patch(`/domain_verifications/${domain.verification.id}/`, data)
          } else if (domain.verification.code) {
            data.domain = domain.verification.domain
            await this.axios.post(`/domain_verifications/`, data)
          }
        } catch {
          hasError = true
        }
      })
      this.isLoading = false
      if (hasError) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "facebook_meta_tag": "Facebook domain meta-tag verification",
    "facebook_meta_tag_text": "Copy and paste your facebook meta-tag's content in fields below"
  },
  "id": {
    "facebook_meta_tag": "Verfikasi domain meta-tag Facebook",
    "facebook_meta_tag_text": "Salin dan tempel konten meta-tag facebook kamu di bawah ini"
  }
}
</i18n>
